import { render } from "./SimplePerf2.vue?vue&type=template&id=dd4abe32&scoped=true&ts=true"
import script from "./SimplePerf2.vue?vue&type=script&lang=ts"
export * from "./SimplePerf2.vue?vue&type=script&lang=ts"

import "./SimplePerf2.vue?vue&type=style&index=0&id=dd4abe32&scoped=true&lang=css"
import "./SimplePerf2.vue?vue&type=style&index=1&id=dd4abe32&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd4abe32"]])

export default __exports__